import { get, post, put } from '../Services/http';
import { load as loadCart } from './Cart.action';
import { catchError } from './Error.action';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS = 'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_CUSTOMER_INFO = 'CHECKOUT_SET_CUSTOMER_INFO';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_CAMPAIGN_CODE = 'CHECKOUT_SET_CAMPAIGN_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION = 'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_DONE = 'CHECKOUT_SUBMIT_DONE';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const RELOAD_DELIVERY_METHODS = 'RELOAD_DELIVERY_METHODS';
export const CHECKOUT_SET_PALLETFREE = 'CHECKOUT_SET_PALLETFREE';
export const CHECKOUT_SET_REQUIREPALLET = 'CHECKOUT_SET_REQUIREPALLET';
export const UPDATE_CREDIT_LIMIT = 'UPDATE_CREDIT_LIMIT';
export const CHECKOUT_SET_LOCK = 'CHECKOUT_SET_LOCK';

export const setBusinessCustomer = (isBusinessCustomer) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_PRIVATE_CUSTOMER,
        payload: {
            isBusinessCustomer,
            selectedDeliveryMethod: null,
            selectedPaymentMethod: null,
            paymentWidget: null
        }
    });

    const { payload } = getState().checkout;
    return put('/api/checkout/setCompany', payload)
        .then(response => response.json())
        // .then(result => {
        //     dispatch(loadCart());
        //     dispatch(setPaymentWidget(result.paymentWidget));
        // })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
}


export const setSignUp = (signUp) => ({
    type: CHECKOUT_SET_SIGN_UP,
    payload: {
        signUp,
    }
})

export const setAlternativeAddress = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'alternativeAddress',
        data: {
            [propName]: value,
        },
    }
})
export const setBillingAddress = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'billingAddress',
        data: {
            [propName]: value,
        },
    }
})

export const setDeliveryAddress = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'deliveryAddress',
        data: {
            [propName]: value,
        },
    }
})
export const setCustomerDetails = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'customerDetails',
        data: {
            [propName]: value,
        },
    }
})

export const setSelectedCompanyAddress = (selectedCompanyAddressId) => ({
    type: CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
    payload: {
        selectedCompanyAddressId,
    }
})


export const setpalletFree = (palletFree) => {
    return {
        type: CHECKOUT_SET_PALLETFREE,
        payload: !palletFree
    }
}

export const setRequirePallet = (requirePallet) => {
    return {
        type: CHECKOUT_SET_REQUIREPALLET,
        payload: requirePallet
    }
}


export const setDelivery = (systemId, palletFree, refreshWidget = true) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
            selectedDeliveryMethod: systemId,
palletFree: palletFree
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setDeliveryProvider', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            if (result !== null && result.paymentWidget.displayDeliveryMethods || refreshWidget) {
                dispatch(setPaymentWidget(result.paymentWidget));
            }
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
}

export const setCountry = (systemId) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_COUNTRY,
        payload: {
            selectedCountry: systemId,
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setCountry', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));
            dispatch({
                type: CHECKOUT_SET_DELIVERY,
                payload: {
                    deliveryMethods: result.deliveryMethods,
                    selectedDeliveryMethod: result.selectedDeliveryMethod,
                }
            });
            dispatch({
                type: CHECKOUT_SET_PAYMENT,
                payload: {
                    paymentMethods: result.paymentMethods,
                    selectedPaymentMethod: result.selectedPaymentMethod,
                }
            });
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
}

export const setPayment = (systemId) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_PAYMENT,
        payload: {
            selectedPaymentMethod: systemId,
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setPaymentProvider', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
}

export const reloadPayment = () => (dispatch, getState) => {
    const { paymentWidget, selectedPaymentMethod } = getState().checkout.payload;
    if (!paymentWidget) {
        return;
    }
    return dispatch(setPayment(selectedPaymentMethod));
}

const setPaymentWidget = (paymentWidget) => ({
    type: CHECKOUT_SET_PAYMENT_WIDGET,
    payload: {
        paymentWidget,
    }
})

export const setOrderNote = (orderNote) => ({
    type: CHECKOUT_SET_ORDER_NOTE,
    payload: {
        orderNote,
    }
})

export const acceptTermsOfCondition = (acceptTermsOfCondition) => ({
    type: CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
    payload: {
        acceptTermsOfCondition,
    }
})

export const setCampaignCode = (campaignCode) => ({
    type: CHECKOUT_SET_CAMPAIGN_CODE,
    payload: {
        campaignCode,
    }
})

export const submitCompanyAddress = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return post('/api/checkout/setCompanyAddress', {
        companyAddressId: payload.selectedCompanyAddressId
    })
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            // reset error of campaign code
            dispatch(submitError({
                modelState: {
                    'companyAddress': []
                } 
            }))
        })
        .catch(ex => {
            dispatch(catchError(ex, error => submitError(error)));
            // restore the initial cart
            dispatch(loadCart());
        })
}

export const submitCampaignCode = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return put('/api/checkout/setCampaignCode', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));
            // reset error of campaign code
            dispatch(submitError({
                modelState: {
                    'campaignCode': []
                } 
            }))
        })
        .catch(ex => {
            dispatch(catchError(ex, error => submitError(error)));
            // restore the initial cart
            dispatch(loadCart());
        })
}

export const submitOrderNote = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return put('/api/checkout/setOrderNote', payload.orderNote)
        .then(_ => {
            dispatch(submitError({
                modelState: {
                    'orderNote': []
                } 
            }))
        })
        .catch(ex => {
            dispatch(catchError(ex, error => submitError(error)));
            // restore the initial cart
            dispatch(loadCart());
        })
}

export const submit = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return _submit('/api/checkout', payload, dispatch);
}

export const verify = (url, orderId, payload) => (dispatch, getState) => {
    const model = getState().checkout.payload;
    model.orderId = orderId;
    model.payload = payload;
    return _submit(url, model, dispatch);
}

const _submit = (url, model, dispatch) => {
    return post(url, model)
        .then(response => response.json())
        .then(result => {
            dispatch(submitDone(result));
            return result; // <-- return the result for further chaining
        })
        .catch(ex => {
            if (ex.response) {
                return ex.response.json().then(error => {
                    dispatch(submitError(error));
                    dispatch(submitDone(null));
                    dispatch(loadCart());
                    throw error;
                });
            } else {
                dispatch(submitError(ex));
                throw ex;
            }
        });
};

export const submitRequest = () => ({
    type: CHECKOUT_SUBMIT,
    payload: {
        isSubmitting: true,
        errors: [],
    },
})

export const submitDone = result => ({
    type: CHECKOUT_SUBMIT,
    payload: {
        result,
        isSubmitting: false,
    },
})

export const submitError = error => ({
    type: CHECKOUT_SUBMIT_ERROR,
    payload: {
        error,
    },
})

export const reloadDeliverySection = () => (dispatch) => {
    return get('/api/checkout/deliveryMethods')
        .then(response => response.json())
        .then(deliveryMethods => dispatch(receiveDeliveryMethods(deliveryMethods)))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const receiveDeliveryMethods = deliveryMethods => ({
    type: RELOAD_DELIVERY_METHODS,
    payload: deliveryMethods
});


export const updateCreditLimit = data => ({
    type: UPDATE_CREDIT_LIMIT,
    data
});

export const reloadCreditLimit = () => (dispatch) => {
    return get('api/checkout/updateCreditLimit')
            .then(r => r.json())
            .then(result => dispatch(updateCreditLimit(result)))
            .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const unlockCheckout = () => ({
    type: CHECKOUT_SET_LOCK,
    payload: {
        locked: false
    }
})

export const lockCheckout = () => ({
    type: CHECKOUT_SET_LOCK,
    payload: {
        locked: true
    }
})